import { Injectable } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { LoadingComponent } from '../shared/components/loading/loading.component';
import { BehaviorSubject, NEVER, Observable, defer, finalize, of, share } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  loading!: HTMLIonModalElement;
  isLoading: boolean = false;
  public show$= new BehaviorSubject<boolean>(false);
  constructor(
    private loadingCtrl: LoadingController,
    private _dialog: ModalController
  ) {}

  async show() {
   this.setLoading(true)
  }

  async hide() {
    this.setLoading(false)
  }

  setLoading(loading: boolean): void {
    this.show$.next(loading);
  }

  getLoading(): Observable<boolean> {
    return this.show$.asObservable();
  }

}
